import { __awaiter, __generator } from "tslib";
import { CoreVideoSdk } from './core-video-sdk-js';
export * from '@sky-uk-ott/core-video-sdk-js-core/lib/public-api';
export { CoreVideoSdk };
export var loadSdk = function (sdkConfig, device, videoPlatformIntegrationProvider) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, CoreVideoSdk.initialise(sdkConfig, device, videoPlatformIntegrationProvider)];
            case 1:
                _a.sent();
                return [2 /*return*/, CoreVideoSdk];
        }
    });
}); };
export var getInitialisedCoreVideoSdk = function () {
    if (!CoreVideoSdk.isInitialised) {
        throw new Error('Core SDK is not initialised');
    }
    return CoreVideoSdk;
};
export var registerCoreVideoSdkLogHandler = function (logHandler) {
    CoreVideoSdk.registerLogHandler(logHandler);
};
//# sourceMappingURL=index.js.map